function version(state = { data: {}, initialized: false }, action) {
	switch (action.type) {
		case "version/set":
			return {
				...state,
				...action.payload,
			};

		default:
			return state;
	}
}

export default version;
